import { F as Formable } from '../FormableHOC-55263162.js';
import CheckboxField from '../ValidatableCheckbox/index.js';
import '../_rollupPluginBabelHelpers-e8fb2e5c.js';
import 'react';
import '../index-a0e4e333.js';
import 'prop-types';
import '../dateValidation-67caec66.js';
import '../_commonjsHelpers-24198af3.js';
import 'react-dom';
import '../hooks/useMount.js';
import '../configs-fed6ac34.js';
import '../index-262edd7a.js';
import '../guid-8ddf77b3.js';
import '../Checkbox/index.js';
import '../index-6ff23041.js';
import '../Tooltip/index.js';
import '../Popover-f4d1cac0.js';
import '../hooks/useDeviceType.js';
import '../hooks/useWindowSize.js';
import '../GeneUIProvider/index.js';
import '../style-inject.es-746bb8ed.js';
import '../checkboxRadioSwitcher-5b69d7bd.js';

var FormableCheckbox = Formable(CheckboxField);

export { FormableCheckbox as default };
